"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.loadFonts = void 0;
function loadFonts() {
    if (typeof window === 'undefined') {
        return;
    }
    const link = document.createElement('link');
    link.href = 'https://fonts.googleapis.com/css?family=Source+Sans+Pro:300,400,600';
    link.rel = 'stylesheet';
    const head = document.getElementsByTagName('head')[0];
    head.appendChild(link);
}
exports.loadFonts = loadFonts;
//# sourceMappingURL=fonts.js.map